define( 'auth-media-gateway/vo/MediaItemResponseVO',['require','exports','module','auth-media-gateway/subclasses/MediaFrameworkResponseHelper','auth-media-gateway/subclasses/Utils'],function( require, exports, module ) {

    var MediaFrameworkResponseHelper = require('auth-media-gateway/subclasses/MediaFrameworkResponseHelper');
    var Utils = require('auth-media-gateway/subclasses/Utils');
    var _ensureArray = function(obj) {
        return (obj instanceof Array) ? obj : (typeof obj !== 'undefined') ? [obj] : [];
    };

    function MediaItemResponseVO(mediaResponse){

        var media_item,
            isAuthorized,
            isLoginRequired,
            isVideoNotBlackedOut,
            videoBlackoutStatus,
            url,
            retVal,
            features = [],
            i;


        var mfResponseHelper = new MediaFrameworkResponseHelper(mediaResponse);
        isAuthorized = mfResponseHelper.isAuthorized();
        isLoginRequired = mfResponseHelper.isLoginRequired();
        videoBlackoutStatus = mfResponseHelper.getBlackoutStatus();
        isVideoNotBlackedOut = !mfResponseHelper.isVideoBlackedOut(videoBlackoutStatus);

        //grab the user verified media item vo and pull out the url (if any is available)
        var tmpContentItem = ($.isArray(mediaResponse.user_verified_event.user_verified_content)) ? mediaResponse.user_verified_event.user_verified_content[0] : mediaResponse.user_verified_event.user_verified_content;
        media_item = ($.isArray(tmpContentItem.user_verified_media_item)) ? tmpContentItem.user_verified_media_item[0] : tmpContentItem.user_verified_media_item;

        tmpContentItem.domainAttributes = MediaFrameworkResponseHelper.getDomainAttributesObject(tmpContentItem);

        var featuresVO = mediaResponse.user_verified_event.user_verified_content.features;
        if (typeof featuresVO !== "undefined" && featuresVO != null) {
            if (typeof featuresVO.feature !== "undefined" && featuresVO.feature != null) {
                features = _ensureArray(featuresVO.feature);
            }
        }

        url = media_item.url;


        var mediaFrameworkSessionCookies = [];
        try {
            /* Sample of what this node looks like
             <session-info>
             <session-attributes>
             <session-attribute name="mediaAuth_v2" value="e3a8cff5910f220164a55042ac35b339b24eed30da31ce6771d298b82b6b9aa337540fc6e6a198aa01b5763db6598350fad231df6a5f541f3fcbf0e03af43ad0e75619d8a7728abf3a906d779fbd2cb1c73be8bb7d475a38462c7e7eb0116791720ced0f507a115fbf29457818daf4eef3b937e827ad9e31bc8275c3c87313dbb981c6338d9f6b5689650c77dfcd39993feab96857d548fd2bc5768f22e4aa9ea309aaed49bccd9e1f8e03dc381737cb6eb79bcd3f978506a8bd8e7ac0d29cb0bd53730cf4e75519ed7e23b8624fe253425c25ae0fab8741ad44828c3fe59b9ff98fa23009b9f340c43243c9b482b5665d22667047936e40ae298adfdbb343c150da1dfdfbedc89cfef10af7f43a8ad10f282363b11479df85d2907aebc0f67ef5786a00d759a06e5c7e1cc576bfcaf9700e202db5cc643e0e7329000e8370ad4de89a8e0570093526a1d0a3dd652e756087a49962e4e41a3a5c4b15f81f96ac4d92df5d08df2821291fb6f26fc0f17f"/>
             </session-attributes>
             </session-info>
             */
            // Grab mediaAuth cookie value(s) if present (should only apply to HLS playback scenarios)
            var sessionAttributes = mediaResponse.session_info.session_attributes;
            if (typeof sessionAttributes !== "undefined" && sessionAttributes != null) {
                if (typeof sessionAttributes.session_attribute !== "undefined" && sessionAttributes.session_attribute != null) {
                    mediaFrameworkSessionCookies = _ensureArray(sessionAttributes.session_attribute);
                }
            }
        } catch (error) {
            Utils.log("MediaItemResponseVO constructor: error grabbing cookie values from the response");
        }

        //return an object with useful values at the top level
        this.url = url;
        this.isAuthorized = isAuthorized;
        this.isLoginRequired = isLoginRequired;
        this.isNotBlackedOut = isVideoNotBlackedOut;
        this.videoBlackoutStatus = videoBlackoutStatus;
        this.mediaItem = media_item.media_item;
        this.mediaServiceVO = mediaResponse;
        this.features = features;
        this.mfCookies = mediaFrameworkSessionCookies;
    }

    return MediaItemResponseVO;
});

